import Vue from 'vue'
import App from './App.vue'


import router from "./router";
import store from "./store";
import VueSnackbar from "vue-snack";
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
import ButtonSpinner from "@/components/ButtonSpinner";
import MapsView from "@/components/MapsView";
import VueCookie from "vue-cookie";
import Meta from "vue-meta";


import Default from './layouts/Default.vue';
Vue.component("default-layout",Default);


UIkit.use(Icons);
window.UIkit = UIkit;

window._ = require("lodash");

require("./styles/index.scss");
require("vue-snack/dist/vue-snack.min.css");


Vue.config.productionTip = false;

//window.Event = new Vue();

Vue.use(VueSnackbar, {});
Vue.use(VueCookie);
//Vue.use(VueHead);
Vue.use(Meta);

Vue.component("button-spinner", ButtonSpinner);
Vue.component("google-map", MapsView);

/*new Vue({
  render: h => h(App),
}).$mount('#app')*/



new Vue({
  router,
  store,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app');
